module.exports = "/images/vendor/@milestoneslabs/milestones-ui-kit/src/static/project-illustrations/mortgage.svg?328e842732748a6f89e69da43e68be40";